import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Cold = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      fill="none"
      viewBox="0 0 32 32"
      ref={forwardedRef}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15.6875" cy="12.4045" r="7.7375" fill="white" stroke="#2B2F38" strokeWidth="1.4" />
      <path
        d="M15.6493 12.4145L10.7095 9.34115"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6467 12.4045L18.7437 7.47945"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6537 12.1809L20.5493 15.3244"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8062 12.2187L12.9124 17.2659"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7847 10.9789L10.9344 12.2352"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5943 9.86019L19.8078 10.1802"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1794 14.1525L17.8385 16.3628"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4746 15.133L15.7966 16.937"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.109 10.6706L13.3314 8.21848"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1679 9.72484L15.8948 7.61724"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3188 13.7275L20.4383 12.4745"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1549 14.8201L11.6963 14.6859"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.1875 28.842L5.1875 13.717C9.0625 14.967 19.8125 16.592 25.6875 13.717L29.8125 26.217C23.0625 29.717 13.4375 31.092 3.1875 28.842Z"
        fill="#BEE9FC"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5625 14.217L16.6875 25.217L25.8125 14.217"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.8125 28.717L12.5625 21.467"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8125 20.842L29.4375 25.967"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Cold
